var initAcfClientsLogos;

(function ( ) {

    let navToggle = document.getElementById('nav-toggle'),
        siteNavigation = document.getElementById('site-navigation')


    navToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        document.body.classList.toggle('menu-open')
        var x = 'true' == navToggle.getAttribute('aria-expanded') ? 'false' : 'true'
        navToggle.setAttribute('aria-expanded', x)
        siteNavigation.setAttribute('aria-expanded', x)
    })

    // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
    document.addEventListener('click', function (e) {
        if (!siteNavigation.contains(e.target)) {
            document.body.classList.remove('menu-toggled')
            navToggle.setAttribute('aria-expanded', 'false')
        }
    });

    jQuery('.is-style-linked-content-list li').mouseenter(function () {
        let nearestSVG = jQuery(this).parents('.wp-block-group').find('svg');
        jQuery(this).toggleClass('active');
        nearestSVG.find('.bubble').toggleClass('inactive');
        nearestSVG.find('#bubbles').addClass('active');
        nearestSVG.find('#bubbles .bubble:nth-of-type(' + (jQuery(this).index() + 1) + ')').toggleClass('inactive');
    }).mouseleave(function () {
        let nearestSVG = jQuery(this).parents('.wp-block-group').find('svg');
        jQuery(this).toggleClass('active');
        nearestSVG.find('#bubbles').removeClass('active');
        nearestSVG.find('.bubble').removeClass('inactive');
    });

    jQuery('svg #bubbles .bubble').mouseenter(function () {
        let nearestList = jQuery(this).parents('.wp-block-group').find('.is-style-linked-content-list');
        nearestList.find('li:nth-of-type(' + (jQuery(this).index() + 1) + ')').trigger('mouseover');
    }).mouseleave(function () {
        let nearestList = jQuery(this).parents('.wp-block-group').find('.is-style-linked-content-list');
        nearestList.find('li:nth-of-type(' + (jQuery(this).index() + 1) + ')').trigger('mouseleave');
    });

    Fancybox.bind('.wp-block-gallery img', {
        groupAll: true
    });

    Fancybox.bind('.fancybox img', {});

    jQuery('.newsletter-form').submit(function(e) {
        jQuery('.newsletter-form input').css('transition-delay', 0).css('opacity', 0);
        jQuery('.newsletter-response').css('transition-delay', '600ms').css('opacity', 100);
        setTimeout(function() {
            jQuery('.newsletter-response').css('transition-delay', 0).css('opacity', 0);
            jQuery('.newsletter-form input').css('transition-delay', '800ms').css('opacity', 100);
        }, 5000);
    });

    jQuery('.microsoft-bookings-button').click(function() {
        jQuery('#microsoft-bookings-modal').show();
    });

    jQuery('#microsoft-bookings-modal .close-button').click(function() {
        jQuery('#microsoft-bookings-modal').hide();
    });

    initAcfClientsLogos = function () {
        if(jQuery('.acf-clients-logos').size()){

            let multipleOf
            if (jQuery(window).width() >= 768){
                multipleOf = 4
            } else if (jQuery(window).width() >= 500){
                multipleOf = 3
            } else {
                multipleOf = 2
            }

            let resize
            jQuery(window).resize(function(){
                clearTimeout(resize)
                clearInterval(logoLoop)

                if (jQuery(window).width() >= 768){
                    multipleOf = 4
                    resize = setTimeout(displayGrid, 100);

                } else if (jQuery(window).width() >= 500){
                    multipleOf = 3
                    resize = setTimeout(displayGrid, 100);

                } else if (jQuery(window).width() < 500) {
                    multipleOf = 2
                    resize = setTimeout(displayGrid, 100);
                }
            })

            const clientLogos = jQuery('.acf-clients-logos .client-logo')
            const alphabet = 'abcdefghijklmnopqrstuvwxyz'
            let numberOfSpaces
            let lettersForGrid
            let count
            let leftOver
            let logoLoop

            const displayGrid = function() {

            numberOfSpaces = multipleOf * (Math.floor(clientLogos.size() / multipleOf))

            lettersForGrid = alphabet.slice(0, numberOfSpaces)

            const numberOfRows = lettersForGrid.length / multipleOf

            // letters need to be seperated by a space
            // groups of letters need to be in ""
            const arrayOfLetters = lettersForGrid.split('')
            let grid = []
            for(let i = 0; i < numberOfRows; i++){
                const row = `"${arrayOfLetters.splice(0, multipleOf).join(' ')}"`
                grid.push(row)
                // console.log(row)
            }
            jQuery(".acf-clients-logos").css('grid-template-areas', `${grid.join(" ")}`);
            // console.log(jQuery(".acf-clients-logos").css('grid-template-areas'))

            const startingLogos = clientLogos.slice(0, numberOfSpaces)
            startingLogos.each(function(index) {
                const gridLocation = lettersForGrid[index]
                jQuery(this).addClass('fadeIn').removeClass('hidden fadeOut').css('grid-area', gridLocation).attr('grid-area', gridLocation)
            })

            if(clientLogos.size() === numberOfSpaces) return

            const extraLogos = clientLogos.slice(numberOfSpaces - clientLogos.size())
            extraLogos.each(function(index){
                jQuery(this).addClass('hidden fadeOut').attr('grid-area', index)
            })
            leftOver = extraLogos.size()
            count = extraLogos.size()

            logoLoop = setInterval(showLogo, 3000);
            }

            const showLogo = function(){
                const randomNumber = Math.floor(Math.random() * numberOfSpaces)
                const randomLetter = lettersForGrid[randomNumber]

                const logoToBeRemoved = jQuery(`.client-logo[grid-area=${randomLetter}]`)
                logoToBeRemoved.toggleClass('fadeOut fadeIn').attr('grid-area', count)

                const onDeckLogo = jQuery(`.client-logo[grid-area="${count - leftOver}"]`)
                onDeckLogo.css('grid-area', randomLetter).removeClass('hidden').attr('grid-area', randomLetter)

                const fadeIn = function(){

                    onDeckLogo.removeClass('fadeOut').addClass('fadeIn')
                    count++
                }

                setTimeout(fadeIn, 1000)

            }

            displayGrid()

        }
    }

    // Modify Language switch link length (2 characters)
    const targetLang = document.querySelector('.site-header__subnav--wrapper .desktop-language-switcher .wpml-ls-native');
    if(targetLang) {
        targetLang.innerText = targetLang.innerText.slice(0, 2);
    }

    // Bigmenu
    // document.documentElement.style.setProperty('--headerStickyTranslate', '0px');
    // document.documentElement.style.setProperty('--headerStickyOpacity', 0);
    // let maxSubMenuHeight = 0;
    // const headerWrapper = document.querySelector('.site-header__wrapper');
    // const headerHeight = headerWrapper.clientHeight;

    // jQuery('.site-header__wrapper .menu-item.menu-item-has-children').each(function (index, element) {
    //     var cuHeight = jQuery(element).find('.sub-menu:eq(0)').prop('scrollHeight');
    //     if(cuHeight > maxSubMenuHeight) {
    //         maxSubMenuHeight = cuHeight;
    //         document.documentElement.style.setProperty('--headerMaxHeight', maxSubMenuHeight);
    //     }
    // });

    // var _show_white_bg = (height) => {
    //     headerWrapper.classList.add('show-submenu');
    //     document.documentElement.style.setProperty('--headerStickyTranslate', (headerHeight) + 'px');
    //     document.documentElement.style.setProperty('--headerStickyOpacity', 1);
    //     if(height) {
    //         document.documentElement.style.setProperty('--headerStickyTranslate', (height) + 'px');
    //     } else {
    //         document.documentElement.style.setProperty('--headerStickyTranslate', (headerHeight) + 'px');
    //     }
    // }

    // var _hide_white_bg = () => {
    //     headerWrapper.classList.remove('show-submenu');
    //     document.documentElement.style.setProperty('--headerStickyTranslate', '0px');
    //     document.documentElement.style.setProperty('--headerStickyOpacity', 0);
    // }

    // const menuHoverSelectors = [
    //     '.site-header__wrapper #menu-primary-menu .menu-item.menu-item-has-children > a',
    //     '.site-header__wrapper #menu-primary-menu .menu-item.menu-item-has-children > span',
    //     '.site-header__wrapper #menu-primary-menu .menu-item.menu-item-has-children .sub-menu',
    // ];
    // jQuery(menuHoverSelectors.join(',')).on('mouseover', function(e) {
    //     e.preventDefault();
    //     _show_white_bg(maxSubMenuHeight + headerHeight);
    // });
    // jQuery('.site-header__wrapper #menu-primary-menu .menu-item.menu-item-has-children .sub-menu').on('mouseover', function(e) {
    //     e.preventDefault();
    //     _show_white_bg(maxSubMenuHeight + headerHeight);
    // });

    // jQuery('.site-header__wrapper #menu-primary-menu .menu-item.menu-item-has-children').on('mouseout', function(e) {
    //     _hide_white_bg();
    // });

    // jQuery('.site-header__wrapper').on('mouseout', function() {
    //     _hide_white_bg();
    // } );

    /**
     * Sidebar case-study
     */
    if(document.querySelector('.sidebar-case-study__toggle')) {
        console.log('oui');
        document.querySelector('.sidebar-case-study__toggle').addEventListener('click', (e) => {
            console.log('click');
            e.preventDefault();
            document.querySelector('.sidebar-case-study__wrapper').classList.toggle('is-visible');
        });
    }

    if(document.querySelector('.sidebar-case-study__close')) {
        console.log('oui');
        document.querySelector('.sidebar-case-study__close').addEventListener('click', (e) => {
            console.log('click');
            e.preventDefault();
            document.querySelector('.sidebar-case-study__wrapper').classList.remove('is-visible');
        });
    }

    /**
     * Fragments
     */
    const fragments = document.querySelectorAll('[data-fragment]');
    if (fragments) {
        const fragmentsData = {};

        fragments.forEach((fragment, key) => {
        fragmentsData[`${fragment.dataset.fragment}_${key}`] = {
            'wrapper': fragment,
            'action': fragment.dataset.fragment,
            'variables': fragment.dataset.variables,
        }
        });

        const data = new URLSearchParams();

        data.append('action', 'get_fragments');
        data.append('nonce', window.base_ajax_object.nonce);
        data.append('language', document.documentElement.lang);
        data.append('fragments', JSON.stringify(fragmentsData));
        data.append('returnHtml', null);

        fetch(`${window.base_ajax_object.ajaxurl}`, {
            method: 'POST',
            headers: { 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: data,
        })
            .then(response => response.json())
            .then(function (data) {
                for (var key in fragmentsData) {
                    if (fragmentsData.hasOwnProperty(key)) {
                        var fragmentData = fragmentsData[key];
                        fragmentData.wrapper.innerHTML = data[key].returnHtml;

                        initAcfClientsLogos();
                        if (typeof initAcfLogosSlider === 'function') {
                            initAcfLogosSlider();
                        }
                    }
                }
            }).catch(function (ex) {
                console.log('parsing failed', ex)
            });
    }
})()
